
import React from "react";

function AddIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="#f5ba13"
      version="1.1"
      viewBox="0 0 537.947 537.947"
      xmlSpace="preserve"
    >
      <path d="M268.974 0C120.411 0 0 120.411 0 268.974s120.411 268.973 268.974 268.973 268.973-120.334 268.973-268.973C537.947 120.334 417.537 0 268.974 0zM394.51 286.033c0 11.857-9.715 21.496-21.496 21.496h-64.566v64.566c0 11.857-9.715 21.496-21.496 21.496h-35.878c-11.857 0-21.497-9.715-21.497-21.496v-64.566h-64.566c-11.857 0-21.497-9.715-21.497-21.496v-35.878c0-11.857 9.715-21.497 21.497-21.497h64.566v-64.566c0-11.857 9.715-21.496 21.497-21.496h35.878c11.857 0 21.496 9.715 21.496 21.496v64.566h64.566c11.857 0 21.496 9.716 21.496 21.497v35.878z"></path>
    </svg>
  );
}

export default AddIcon;
